var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 348,
    viewBox: "0 0 348 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.504 0H145.007V14.4963H159.504V0Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.489 0H202.993V14.4963H217.489V0Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.993 14.4963H101.496V28.9927H115.993V14.4963Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.007 14.4963H130.511V28.9927H145.007V14.4963Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 14.4963H159.504V28.9927H174V14.4963Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.993 14.4963H188.496V28.9927H202.993V14.4963Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.007 14.4963H217.511V28.9927H232.007V14.4963Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 14.4963H246.504V28.9927H261V14.4963Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5037 28.9927H58.0073V43.489H72.5037V28.9927Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.496 28.9927H87V43.489H101.496V28.9927Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.489 28.9927H115.993V43.489H130.489V28.9927Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 28.9927H145.007V43.489H159.504V28.9927Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.496 28.9927H174V43.489H188.496V28.9927Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.489 28.9927H202.993V43.489H217.489V28.9927Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.504 28.9927H232.007V43.489H246.504V28.9927Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 43.511H72.5037V58.0073H87V43.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.993 43.511H101.496V58.0073H115.993V43.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.007 43.511H130.511V58.0073H145.007V43.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.007 43.511H217.511V58.0073H232.007V43.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 43.511H246.504V58.0073H261V43.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.489 58.0073H28.9927V72.5037H43.489V58.0073Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5037 58.0073H58.0073V72.5037H72.5037V58.0073Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.496 58.0073H87V72.5037H101.496V58.0073Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.496 58.0073H174V72.5037H188.496V58.0073Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.489 58.0073H202.993V72.5037H217.489V58.0073Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.496 58.0073H261V72.5037H275.496V58.0073Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.489 58.0073H289.993V72.5037H304.489V58.0073Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 72.5037H72.5037V87H87V72.5037Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 72.5037H246.504V87H261V72.5037Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.993 72.5037H275.496V87H289.993V72.5037Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.489 87H28.9927V101.496H43.489V87Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5037 87H58.0073V101.496H72.5037V87Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.489 87H115.993V101.496H130.489V87Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.489 87H202.993V101.496H217.489V87Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.489 87H289.993V101.496H304.489V87Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.504 87H319.007V101.496H333.504V87Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0073 101.496H43.511V115.993H58.0073V101.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.993 101.496H275.496V115.993H289.993V101.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.007 101.496H304.511V115.993H319.007V101.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4963 115.993H0V130.489H14.4963V115.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.489 115.993H28.9927V130.489H43.489V115.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5037 115.993H58.0073V130.489H72.5037V115.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.496 115.993H87V130.489H101.496V115.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.489 115.993H115.993V130.489H130.489V115.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.504 115.993H232.007V130.489H246.504V115.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.496 115.993H261V130.489H275.496V115.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.489 115.993H289.993V130.489H304.489V115.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9927 130.511H14.4963V145.007H28.9927V130.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0073 130.511H43.511V145.007H58.0073V130.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.007 130.511H304.511V145.007H319.007V130.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.489 145.007H28.9927V159.504H43.489V145.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.496 145.007H261V159.504H275.496V145.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.504 145.007H319.007V159.504H333.504V145.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9927 159.504H14.4963V174H28.9927V159.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 159.504H72.5037V174H87V159.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.007 159.504H304.511V174H319.007V159.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 159.504H333.504V174H348V159.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4963 174H0V188.496H14.4963V174Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.489 174H28.9927V188.496H43.489V174Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.504 174H319.007V188.496H333.504V174Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9927 188.496H14.4963V202.993H28.9927V188.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0073 188.496H43.511V202.993H58.0073V188.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.007 188.496H217.511V202.993H232.007V188.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.007 188.496H304.511V202.993H319.007V188.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.489 202.993H28.9927V217.489H43.489V202.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.489 202.993H115.993V217.489H130.489V202.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.496 202.993H261V217.489H275.496V202.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.489 202.993H289.993V217.489H304.489V202.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.504 202.993H319.007V217.489H333.504V202.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9927 217.511H14.4963V232.007H28.9927V217.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0073 217.511H43.511V232.007H58.0073V217.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.007 217.511H304.511V232.007H319.007V217.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 217.511H333.504V232.007H348V217.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.489 232.007H28.9927V246.504H43.489V232.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5037 232.007H58.0073V246.504H72.5037V232.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.496 232.007H87V246.504H101.496V232.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.496 232.007H261V246.504H275.496V232.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.489 232.007H289.993V246.504H304.489V232.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9927 246.504H14.4963V261H28.9927V246.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0073 246.504H43.511V261H58.0073V246.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 246.504H159.504V261H174V246.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.993 246.504H275.496V261H289.993V246.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.007 246.504H304.511V261H319.007V246.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5037 261H58.0073V275.496H72.5037V261Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.496 261H87V275.496H101.496V261Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.489 261H115.993V275.496H130.489V261Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.489 261H202.993V275.496H217.489V261Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.504 261H232.007V275.496H246.504V261Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.496 261H261V275.496H275.496V261Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.489 261H289.993V275.496H304.489V261Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0073 275.496H43.511V289.993H58.0073V275.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 275.496H72.5037V289.993H87V275.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 275.496H159.504V289.993H174V275.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.993 275.496H188.496V289.993H202.993V275.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 275.496H246.504V289.993H261V275.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.007 275.496H304.511V289.993H319.007V275.496Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.496 289.993H87V304.489H101.496V289.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.489 289.993H115.993V304.489H130.489V289.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.504 289.993H232.007V304.489H246.504V289.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.496 289.993H261V304.489H275.496V289.993Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 304.511H72.5037V319.007H87V304.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.993 304.511H101.496V319.007H115.993V304.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.007 304.511H130.511V319.007H145.007V304.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 304.511H159.504V319.007H174V304.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.993 304.511H188.496V319.007H202.993V304.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.007 304.511H217.511V319.007H232.007V304.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.993 304.511H275.496V319.007H289.993V304.511Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.496 319.007H87V333.504H101.496V319.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 319.007H145.007V333.504H159.504V319.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.496 319.007H174V333.504H188.496V319.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.489 319.007H202.993V333.504H217.489V319.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.504 319.007H232.007V333.504H246.504V319.007Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.007 333.504H130.511V348H145.007V333.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 333.504H159.504V348H174V333.504Z",
    fill: "#E41E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.993 333.504H188.496V348H202.993V333.504Z",
    fill: "#E41E20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 348,
    height: 348,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/logo-big.6cf93f13c774454fed0c5ae15c997eb9.svg";
export { ForwardRef as ReactComponent };